import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

import ProductCard from "../ProductCard/Productcard";

import ProductGrid from "../ProductGrid/ProductGrid";
import Sortfilter from "../SortFilter/SortFilter";
import Skeleton from "../Skeleton/SkeletonCard";

const nos = [1, 2, 3, 4];
const Product = () => {
  const search = useLocation().search;
  const query = new URLSearchParams(search).get("products");

  const [productArray, setProductArray] = useState([]);

  const [apifetched, setApiFetched] = useState(false);

  useEffect(() => {
    axios.get("https://buyist.herokuapp.com/api/product").then((res) =>
      setTimeout(() => {
        setProductArray(res.data.array);
        setApiFetched(true);
      }, 1000)
    );
  }, []);

  const filteredProducts = useMemo(() => {
    return productArray.filter((product) =>
      product.name.toLowerCase().includes(query)
    );
  }, [query, productArray]);

  return (
    <div className="w-full">
      <Sortfilter />
      <ProductGrid>
        {apifetched
          ? filteredProducts.length > 0
            ? filteredProducts.map((product, index) => (
                <ProductCard key={index} product={product} />
              ))
            : productArray.map((product, index) => (
                <ProductCard key={index} product={product} />
              ))
          : nos.map((i, key) => {
              return <Skeleton key={i} />;
            })}
      </ProductGrid>
    </div>
  );
};

export default Product;
